import "./index.css";
import { main } from "./app/main";

main();
